import * as z from "zod";

export const localeSchema = z.enum(["en", "fr"]);
export type Locale = z.infer<typeof localeSchema>;
